<template>
  <div class="content">
    <div class="title">系统设置</div>
    <div class="subTitle">硬件绑定</div>

    <div class="subTitle-switch">
      <el-row>
        <el-col :span="1">
          <el-switch v-model="value1" @change="submit">
          </el-switch>
        </el-col>
        <el-col :span="3">是否启用硬件绑定</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { API__code, API_Admin} from '../../../api/index.js'
export default {
  data(){
    return{
      value1:true,
      checkCode:'',
      token:''
    }
  },
  created(){
      this.getCookie();
      var param = {
        id:this.$route.query.companyId,
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Admin.getCompany(param)
        .then((res) => {
          this.value1 = res.data.data.isbinding == 1?true:false
        })
  },
  methods:{
    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'dnnyptadmin_token') {
                    this.token = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    this.checkCode = arr2[1];
                } 
            }
        }
    },
    submit(){
      var param = {
        id:this.$route.query.companyId,
        isbinding:this.value1?1:0,
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Admin.hardwareBinding(param)
        .then((res) => {
          this.$message.success("修改成功")
        })
    }
  }
}
</script>

<style lang="scss" scoped>

.content{
  width: 100%;
  height: 600px;
  position: relative;
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;
  box-sizing: border-box;
}

.title{
  color:#666666;
  font-size: 20px;
}

.subTitle{
  color:#666666;
  font-size: 14px;
  margin-top: 10px;
}

.subTitle-switch{
  color:#666666;
  font-size: 16px;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// system.vue?6bf57470